export class ResponseFromFetch {
    status: any;
    body: any;
}



// WEBPACK FOOTER //
// ./src/app/models/response-from-fetch.model.ts